export default "<hr />\r\n<hr />\r\n<hr />\r\n<hr />\r\n<hr />\r\n<hr />\r\n<hr />\r\n<hr />\r\n<hr />\r\n\r\n<p>facsimile works!</p>";